import {FilterEnum} from 'Agent/Accounts/ducks/account';

export enum LineOfBusiness {
  Agent = 1,
  EnrollmentTracking = 2,
  Beneficiary = 3,
  BOSTools = 4,
  Messaging = 5,
  AppEntry = 6,
}

export const LinesOfBusiness: FilterEnum[] = [
  // {
  //   name: 'Agent',
  //   value: 'agent',
  // },
  // {
  //   name: 'EnrollTrack',
  //   value: 'enrolltrack',
  // },
  {
    name: 'Beneficiary',
    value: 'beneficiary',
  },
  {
    name: 'BOS Tools',
    value: 'bostools',
  },
  // {
  //   name: 'Messaging',
  //   value: 'messaging',
  // },
  {
    name: 'AppEntry',
    value: 'appentry',
  },
];

export type LineOfBusinessValue = 'beneficiary' | 'bostools' | 'appentry';
